import { gql } from '../../../apollo/__generated__';

export const MILESTONES = gql(`
  query Milestones($eventId: ID!) {
    milestones(eventId: $eventId) {
      id
      name
      bedroomValue
      noAlcoholDiscount
      prices {
        day
        value
      }
      isVoucherOnly
      startAt
      endAt
    }
  }
`);
